import { actionTypes } from './action';

var initialState = {
   
}

// // REDUCERS
export const feedback = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LANGUAGE:
        return state;
        // case actionTypes.NEXT:
        //     return { ...state, currentIndex: state.currentIndex + 1 };
        case actionTypes.ERROR:
            return { ...state, errorMessage: action.message };
        case actionTypes.LOADREQ:
        case actionTypes.SUBMITREQ:
            return { ...state, loading: true };
        case actionTypes.RECEIVED:
            return {
                ...state, loading: false,
                questions: action.questions
            };
        case actionTypes.SUBMITDONE:
            return {
                ...state, loading: false,
                message: action.message
            };
        default: return state
    }
}



// WEBPACK FOOTER //
// store/feedback/reducer.ts